import { mainNum } from '../constants'

const validates = {
    displayImagesMain: {
        name: 'displayImagesMain',
        validate: {
            name: '主图',
            validatorNum: mainNum,
            imageTypeValidator: {
                noAcceptTypeList: ['image/gif'],
            },
            ratioValidator: {
                ratio: 1,
            },
            maxSize: 3,
            rectValidator: {
                minWidth: 480,
                minHeight: 480,
            },
        },
    },
    displayImages: {
        name: 'displayImages',
        validate: {
            name: '规格图',
            imageTypeValidator: {
                noAcceptTypeList: ['image/gif'],
            },
            ratioValidator: {
                ratio: 1,
            },
            maxSize: 3,
            rectValidator: {
                minWidth: 480,
                minHeight: 480,
            },
        },
    },
    transparentImageUrl: {
        name: 'transparentImageUrl',
        validate: {
            name: '透明素材图',
            imageTypeValidator: {
                acceptTypeList: ['image/png'],
            },
            sizeValidator: {
                maxSize: 3,
            },
            rectValidator: {
                minWidth: 480,
                minHeight: 480,
            },
            ratioValidator: {
                ratio: 1 / 1,
            },
        },
    },
    whiteImageUrl: {
        name: 'whiteImageUrl',
        validate: {
            name: '白底图',
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg'],
            },
            sizeValidator: {
                maxSize: 3,
            },
            rectValidator: {
                minWidth: 480,
                minHeight: 480,
            },
            ratioValidator: {
                ratio: 1 / 1,
            },
        },
    },
}

// 给铺货模版的配置
export const goodsQuickSets = [
    validates.displayImagesMain,
    validates.displayImages,
    validates.transparentImageUrl,
    validates.whiteImageUrl,
    // {
    //     name: 'guideImageList',
    //     validate: {
    //         name: '搜索推荐图'
    //     }
    // }
]

// 商品主图、3:4主图、 白底图, 规格图、白底图
export default validates
